import { useEffect, useState } from 'react';
import { fetchJson } from '../../store/fetch';

export function useCheckHasOrthOInLastSixMonths(patientId: string): boolean | null {
    const [hasOrthOInLastSixMonths, setHasOrthOInLastSixMonths] = useState<boolean | null>(null);

    useEffect(() => {
        checkHasOrthOInLastSixMonths();
    }, []);

    return hasOrthOInLastSixMonths;

    async function checkHasOrthOInLastSixMonths() {
        const result = await fetchJson(`/api/requests/hasOrthOInLastSixMonths/${patientId}`, 'GET');
        setHasOrthOInLastSixMonths(result.json.hasOrthOInLastSixMonths);
    }
}
